import replace from 'lodash/replace'

export default (content, quality = 'medium') => {
  const match = content.match((/<img\s.*?src=(?:'|")([^'">]+)(?:'|")/));
  if (match !== null) {
    return replace(match, 'original', quality);
  }
  return ['', '']
}